var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutlookCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6042 4.3878H13.1248V0.732357C13.1248 0.514341 13.0289 0.308093 12.8612 0.169107C12.6947 0.0302219 12.4715 -0.0298366 12.2616 0.0142434L0.595004 2.20749C0.249364 2.27216 0 2.57327 0 2.9256V19.0108C0 19.3618 0.249364 19.6643 0.595004 19.7289L12.2616 21.9223C12.3053 21.9309 12.3506 21.9354 12.3958 21.9354C12.5649 21.9354 12.7297 21.877 12.8611 21.7671C13.0289 21.6284 13.1248 21.4207 13.1248 21.2041V17.5485H22.6042C23.0068 17.5485 23.3333 17.2208 23.3333 16.8171V5.1191C23.3334 4.71569 23.0069 4.3878 22.6042 4.3878Z",
    fill: "#0169B6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4803 5.85035H13.1257V7.51073L16.0004 9.34388L20.4803 5.85035Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4905 10.8158C16.359 10.9183 16.2 10.9693 16.0425 10.9693C15.9069 10.9693 15.7698 10.9316 15.6515 10.8552L13.1257 9.24447V16.0873H21.876V6.61438L16.4905 10.8158Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.56624 7.3118C4.55662 7.3118 2.92043 9.28018 2.92043 11.6987C2.92043 14.1174 4.55662 16.0856 6.56624 16.0856C8.57586 16.0856 10.2121 14.1174 10.2121 11.6987C10.2121 9.28023 8.57586 7.3118 6.56624 7.3118ZM6.56624 14.6233C5.3602 14.6233 4.37883 13.3118 4.37883 11.6987C4.37883 10.0858 5.3602 8.77425 6.56624 8.77425C7.77228 8.77425 8.75401 10.0859 8.75401 11.6987C8.75401 13.3118 7.77228 14.6233 6.56624 14.6233Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlookCalendar);
export default __webpack_public_path__ + "static/media/outlook_calendar.a0b2bb2a48c9e3dddabfada72259cce8.svg";
export { ForwardRef as ReactComponent };